import { useSelector } from 'react-redux';

export function useGetForm<T>(key: string): T {
  if (!key) return null;
  const state = useSelector((s) => s) as any;
  const form = state.forms[key];
  return form as T;
}
